export const initialState = {
  error: false,
  hasRequested: false,
  logged: false,
  logging: false,
  loginPin: 0,
  tvg3token: "",
  userLogin: false,
  userLogout: true,
  allPromos: [],
  user: {
    accountNumber: "",
    emailAddress: "",
    firstName: "",
    homeAddress: {
      streetNumber: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      stateAbbr: ""
    },
    lastName: "",
    mailingAddress: {
      streetNumber: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      stateAbbr: ""
    },
    primaryPhone: "",
    profile: "PORT-Generic",
    signalProviderId: "",
    status: "",
    transportId: "",
    userName: "",
    wagerStatus: 0,
    accountRoles: ["USER"]
  },
  wasLogin: false,
  optedInPromos: {}
};

const userDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case "USER_DATA_UPDATE": {
      return { ...state, ...action.payload };
    }
    case "USER_LOGGED_STATE": {
      return { ...state, logged: action.payload.isLogged };
    }
    case "USER_ACCOUNT_NUMBER": {
      return {
        ...state,
        user: { ...state.user, accountNumber: action.payload.accountNumber }
      };
    }
    case "USER_PROMOS_SUCCESS": {
      return { ...state, ...action.payload };
    }
    case "USER_PROMOS_SET": {
      return { ...state, allPromos: action.payload };
    }
    default: {
      return state;
    }
  }
};

export default userDataReducer;
